import { FC, ReactElement } from 'react';
import AppModal from '../app-modal/AppModal';
import { Modal } from 'react-bootstrap';
import i18next from 'i18next';
import { PatientTherapyBillingInfoDto } from '../../../../shared/dtos/patient.dto';
import PatientBillingForm from './PatientBillingForm';

type PatientBillingModalProps = {
  show: boolean;
  patientId: string;
  billingInfo?: PatientTherapyBillingInfoDto;
  onClose: () => void;
  onSave: () => void;
}

const PatientBillingModal: FC<PatientBillingModalProps> = ({
  show,
  patientId,
  billingInfo,
  onClose,
  onSave
}: PatientBillingModalProps): ReactElement => {
  return (
    <AppModal show={show} onHide={onClose} backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title>{i18next.t(billingInfo ? 'patientBillingModal.updateTitle' : 'patientBillingModal.createTitle')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <PatientBillingForm 
          patientId={patientId}
          data={billingInfo}
          onClose={onClose} 
          onSubmit={() => {
            onSave();
            onClose();
          }}
        />
      </Modal.Body>
    </AppModal>
  );
};


export default PatientBillingModal;
